import React, {Component} from 'react';
import style from '../css/matchDayLeagueUpdate.css';
import {getText} from '../../../helpers/localization';
import MatchDayLeagueUpdate from "./matchDayLeagueUpdate";

class QuickBetCardMatchDayLeagueTable extends Component {

    constructor(props) {
        super(props);
        let store = this.props.store;
        let storeData = store.getState();
        let leagueUpdate = storeData.vpp.games[storeData.vpp.selectedGameIndex].leagueUpdate;
        this.matchesPlayed = leagueUpdate ? leagueUpdate[0].matchesPlayed : undefined;
        this.state = {
            toggleTable: true, activeRowId: undefined, activeRowToggle: false, activeRowTeamName: undefined,
            games: storeData.vpp.games,
            selectedGameIndex: storeData.vpp.selectedGameIndex,
            selectedEventIndex: storeData.vpp.selectedEventIndex,
        };
    }

    _toggle() {
        let toggleTable = !this.state.toggleTable;
        this.setState({
            toggleTable: toggleTable,
            activeRowId: undefined,
            activeRowToggle: false,
            activeRowTeamName: undefined
        })
    }

    _toggleRow(rowId, teamName) {
        if (this.state.activeRowId == rowId) {
            this.setState({
                toggleTable: this.state.toggleTable,
                activeRowId: undefined,
                activeRowToggle: !this.state.activeRowToggle,
                activeRowTeamName: undefined
            });
        } else {
            this.setState({
                toggleTable: this.state.toggleTable,
                activeRowId: rowId,
                activeRowToggle: true,
                activeRowTeamName: teamName
            });
        }
    }

    componentWillReceiveProps(nextProps) {
        let store = nextProps.store;
        let storeData = store.getState();

        if (nextProps && storeData) {
            if (storeData.vpp.selectedEventIndex != this.state.selectedEventIndex) {
                this.setState({
                    toggleTable: true,
                    activeRowId: undefined,
                    activeRowToggle: false,
                    activeRowTeamName: undefined,
                    selectedGameIndex: storeData.vpp.selectedGameIndex,
                    games: storeData.vpp.games,
                    selectedEventIndex: storeData.vpp.selectedEventIndex,
                })
            } else {
                let leagueUpdate = storeData.vpp.games[storeData.vpp.selectedGameIndex].leagueUpdate;
                if (leagueUpdate && (leagueUpdate[0].matchesPlayed !== this.matchesPlayed)) {
                    this.setState({
                        ...this.state,
                        toggleTable: true,
                        activeRowId: undefined,
                        activeRowToggle: false,
                        activeRowTeamName: undefined,
                    })
                    this.matchesPlayed = leagueUpdate[0].matchesPlayed ? leagueUpdate[0].matchesPlayed : this.matchesPlayed;
                    this.forceUpdate();
                } else {
                    this.setState({
                        ...this.state,
                        selectedGameIndex: storeData.vpp.selectedGameIndex,
                        games: storeData.vpp.games,
                        selectedEventIndex: storeData.vpp.selectedEventIndex,
                    })
                }
            }
        }
    }

    render() {

        let leagueUpdateJson = this.state.games[this.state.selectedGameIndex].leagueUpdate;

        if (leagueUpdateJson === undefined)
            return null;

        let toggleTable = this.state.toggleTable ? style.toggleOutTable : style.toggleInTable;
        let arrow = this.state.toggleTable ? style.leagueUpdateRight : style.leagueUpdateDown;
        let header;
        if (!this.state.toggleTable) {
            header = (<div className={style.leagueUpdateHeader} onClick={() => this._toggle()}>
                <div className={`${style.cellSmall} ${style.middle}`}>
                    <div className={`${arrow} ${style.leagueUpdateHeaderArrow}`}/>
                </div>
                <div className={`${style.cellPos} ${style.middle}`}>
                    <span>{getText('POS', this.props.store)}</span>
                </div>
                <div className={`${style.cellMedium} ${style.middle} ${style.teamName}`}>
                    <p>{getText('TEAM', this.props.store)}</p></div>
                <div className={`${style.cellMedium} ${style.middle}`}><p>{getText('P', this.props.store)}</p></div>
                <div className={`${style.cellMedium} ${style.middle}`}><p>{getText('W', this.props.store)}</p></div>
                <div className={`${style.cellMedium} ${style.middle}`}><p>{getText('D', this.props.store)}</p></div>
                <div className={`${style.cellMedium} ${style.middle}`}><p>{getText('L', this.props.store)}</p></div>
                <div className={`${style.cellMedium} ${style.middle}`}><p>{getText('F', this.props.store)}</p></div>
                <div className={`${style.cellMedium} ${style.middle}`}><p>{getText('A', this.props.store)}</p></div>
                <div className={`${style.cellMedium} ${style.middle}`}><p>{getText('PTS', this.props.store)}</p></div>
                <div className={`${style.cellLarge} ${style.middle}`}><p>{getText('TREND', this.props.store)}</p></div>
            </div>);
        } else {
            header = (<div className={style.leagueUpdateHeader} onClick={() => this._toggle()}>

                <div className={`${style.cellSmall} ${style.middle}`}>
                    <span className={style.noColor}><div
                        className={`${arrow} ${style.leagueUpdateHeaderArrow}`}/></span>
                </div>
                <div className={`${style.cellCollapseTittle} ${style.middle}`}>
                    <p>{getText('LEAGUE TABLE', this.props.store)}</p></div>
            </div>);
        }
        let leagueUpdateUI = leagueUpdateJson.slice(0, leagueUpdateJson.length).map(
            (leagueUpdate, index) => {
                let leagueUpdateRow;
                if (leagueUpdate) {
                    leagueUpdateRow = <MatchDayLeagueUpdate store={this.props.store} leagueUpdate={leagueUpdate}
                                                            activeRow={this.state.activeRowId}
                                                            activeRowToggled={this.state.activeRowToggle} rowId={index}
                                                            key={index}
                                                            trigger={() => this._toggleRow(index, leagueUpdate.teamName)}
                                                            activeRowTeamName={this.state.activeRowTeamName}/>
                }
                return leagueUpdateRow;
            });

        return (
            <div className={style.leagueUpdateUIContainer}>
                <div className={style.leagueUpdateTable}>
                    {header}
                    <div className={toggleTable}>
                        {leagueUpdateUI}
                    </div>
                </div>
            </div>
        );
    }
}

export default (QuickBetCardMatchDayLeagueTable);


// WEBPACK FOOTER //
// ./src/ui-modules/sports-book/components/quickBetCardMatchDayLeagueTable.js